import React from 'react';

import { nextReduxWrapper } from '../../src/client/store/create-store';
import fetchProductsFromParams from '../../src/client/models/product/fetch-products-from-params';
import Page from '../../src/client/pages/pregnancy';

// @ts-expect-error - Automatic, Please fix when editing this file
const PregnancyPage = (props) => (
  <Page
    {...{
      ...{ props },
      match: {
        params: {
          needsProductType: 'hospital-extras',
          needsType: 'pregnancy-cover',
        },
      },
    }}
  />
);

// @ts-expect-error - Automatic, Please fix when editing this file
export const getServerSideProps = nextReduxWrapper.getServerSideProps((store) => async () => {
  await fetchProductsFromParams(store.getState(), store.dispatch, {
    needsProductType: 'hospital-extras',
    needsType: 'pregnancy-cover',
  });
});

export default PregnancyPage;
